import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './contexts/AppContext';
import { Toaster } from './components/ui/sonner';
import { AuthGuard } from './components/AuthGuard';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';
import { AddTransaction } from './components/AddTransaction';
import { Budget } from './components/Budget';
import { Accounts } from './components/Accounts';
import { Reports } from './components/Reports';
import { Settings } from './components/Settings';
import { Schedules } from './components/Schedules';
import './App.css';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-background font-sans antialiased">
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected routes */}
            <Route path="/" element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            } />
            
            <Route path="/add-transaction" element={
              <AuthGuard>
                <AddTransaction />
              </AuthGuard>
            } />
            
            <Route path="/budget" element={
              <AuthGuard>
                <Budget />
              </AuthGuard>
            } />
            
            <Route path="/accounts" element={
              <AuthGuard>
                <Accounts />
              </AuthGuard>
            } />
            
            <Route path="/reports" element={
              <AuthGuard>
                <Reports />
              </AuthGuard>
            } />
            
            <Route path="/settings" element={
              <AuthGuard>
                <Settings />
              </AuthGuard>
            } />
            
            <Route path="/schedules" element={
              <AuthGuard>
                <Schedules />
              </AuthGuard>
            } />
          </Routes>
          
          <Toaster />
        </div>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;